/* eslint-disable @typescript-eslint/naming-convention */
export class TaxonomicStatus {
  public static VALUES = [
    'Taxonomically Determinate',
    'Taxonomically Indistinct',
    'Taxonomically Unresolved',
  ];
}
